// extracted by mini-css-extract-plugin
export default {"component":"NotFound_component__Cgh9N","title":"NotFound_title__OQ-MU","heading":"NotFound_heading__mkbO1","subheading":"NotFound_subheading__P4LcO"};